export enum DataIcon {
    None,
    User,
    Office
}